const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _secondaryControls: {
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    code: {
      name: 'รหัส',
      width: '6rem',
    },
    name: {
      name: 'ชื่อโซน',
      width: '6rem',
      class: {
        text: 'text-left',
        cell: 'text-center',
      },
    },
    locationProvince: {
      name: 'จังหวัด',
      width: '10rem',
      class: {
        text: '',
        cell: 'text-center',
      },
      filter: () => '',
    },
    locationDistrict: {
      name: 'อำเภอ/เขต',
      width: '10rem',
      class: {
        text: '',
        cell: 'text-center',
      },
      filter: () => '',
    },
    locationSubdistrict: {
      name: 'ตำบล/แขวง',
      width: '10rem',
      class: {
        text: '',
        cell: 'text-center',
      },
      filter: () => '',
    },
    zipcode: {
      name: 'รหัสไปรษณีย์',
      width: '6rem',
    },
    // eslint-disable-next-line
    hub_id: {
      name: 'Hub',
      width: '6rem',
      filter: (val: any, row: any) => row.item.hub?.name || '',
    },
    distanceType: {
      name: 'ระยะทาง',
      width: '6rem',
      filter: (val: string) => {
        if (val === 'NEAR') return 'ใกล้';
        if (val === 'MODERATE') return 'กลาง';
        return 'ไกล';
      },
    },
    active: {
      name: 'สถานะการใช้งาน',
      width: '8rem',
    },
    version: {
      name: 'เวอร์ชั่น',
      width: '4rem',
    },
    updatedAt: {
      name: 'วันที่เคลื่อนไหว',
      width: '12rem',
    },
    /* eslint-disable */
    pickupLeasedCost: {
      name: 'ค่าเหมารถกระบะ',
      width: '8rem',
      class: {
        text: 'text-right',
        cell: '',
      },
      filter: (val: string) => val ? toCurrency(val) : '-',
    },
    sixWheelLeasedCost: {
      name: 'ค่าเหมารถหกล้อ',
      width: '8rem',
      class: {
        text: 'text-right',
        cell: '',
      },
      filter: (val: string) => val ? toCurrency(val) : '-',
    },
    tenWheelLeasedCost: {
      name: 'ค่าเหมารถสิบล้อ',
      width: '8rem',
      class: {
        text: 'text-right',
        cell: '',
      },
      filter: (val: string) => val ? toCurrency(val) : '-',
    },
    trailerLeasedCost: {
      name: 'ค่าเหมารถพ่วง',
      width: '8rem',
      class: {
        text: 'text-right',
        cell: '',
      },
      filter: (val: string) => val ? toCurrency(val) : '-',
    },
    pickupTime: {
      name: 'เวลาขนส่งรถกระบะ',
      width: '8rem',
      class: {
        text: 'text-right',
        cell: '',
      },
      filter: (val: string) => val ? toCurrency(val) : '-',
    },
    sixWheelTime: {
      name: 'เวลาขนส่งรถหกล้อ',
      width: '8rem',
      class: {
        text: 'text-right',
        cell: '',
      },
      filter: (val: string) => val ? toCurrency(val) : '-',
    },
    tenWheelTime: {
      name: 'เวลาขนส่งรถสิบล้อ',
      width: '8rem',
      class: {
        text: 'text-right',
        cell: '',
      },
      filter: (val: string) => val ? toCurrency(val) : '-',
    },
    trailerTime: {
      name: 'เวลาขนส่งรถพ่วง',
      width: '8rem',
      class: {
        text: 'text-right',
        cell: '',
      },
      filter: (val: string) => val ? toCurrency(val) : '-',
    },
    /* eslint-enable */
    // 'user.name': {
    //   name: 'ผู้ดำเนินการ',
    //   width: '8rem',
    // },
  },
  sortable: [
    'name',
    'code',
    'distanceType',
  ],
};
